import "./src/assets/scss/main.scss";

// Initialize Prism.js for code blocks in HTML (e.g., side notes)
const highlightCodeBlocks = () => {
  if (typeof window !== "undefined") {
    // Use dynamic import to load Prism.js and the lisp component
    Promise.all([
      import("prismjs"),
      import("prismjs/components/prism-lisp")
    ]).then(([Prism]) => {
      // Highlight all code blocks, including those in HTML
      Prism.highlightAll();
    }).catch((err) => {
      console.warn("Failed to load Prism.js:", err);
    });
  }
};

// Highlight on route changes
export const onRouteUpdate = () => {
  setTimeout(highlightCodeBlocks, 0);
};

// Highlight on initial page load
if (typeof window !== "undefined") {
  // Wait for DOM to be ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", highlightCodeBlocks);
  } else {
    setTimeout(highlightCodeBlocks, 0);
  }
}
